import { Inject, Injectable } from "@angular/core";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { BroadcastQueue } from "@webapp/core/broadcast/models/broadcast.models";
import { IAngularEvent } from "angular";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BroadcastService {
  private messageQueue: BroadcastQueue = new BroadcastQueue();

  constructor(@Inject("$rootScope") private rootScope: IGtmhubRootScopeService) {}

  public emit<BroadcastMessageType>(name: string, args: BroadcastMessageType): void {
    // creating the subject if not present
    this.setSubjectInMessageQueue(name);
    // emitting the subject value
    this.messageQueue[name].next(args);
    // preserve the original Root Scope for Angular.js until we do not need it anymore
    this.rootScope.$broadcast(name, args);
  }

  public on<BroadcastMessageType>(name: string): Subject<BroadcastMessageType> {
    // creating the subject if not present (usually, as you subscribe to something which later gets emitted)
    this.setSubjectInMessageQueue(name);

    this.rootScope.$on(name, (evt: IAngularEvent, args: BroadcastMessageType) => this.messageQueue[name].next(args));

    return this.messageQueue[name] as Subject<BroadcastMessageType>;
  }

  private setSubjectInMessageQueue(name: string): void {
    if (!this.messageQueue[name]) {
      this.messageQueue[name] = new Subject();
    }
  }
}
